import { render, staticRenderFns } from "./aFeeDetailHis.vue?vue&type=template&id=f352e782&scoped=true"
import script from "./aFeeDetailHis.vue?vue&type=script&lang=js"
export * from "./aFeeDetailHis.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailHis.vue?vue&type=style&index=0&id=f352e782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f352e782",
  null
  
)

export default component.exports